import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '@teorema/patron';
import { FilterField, FilterOperator, Ticket } from 'src/app/models';
import { TcDataService, TcTicketService } from 'src/app/shared/services';

@Component({
  selector: 'app-recently-viewed-tickets',
  templateUrl: './recently-viewed-tickets.component.html',
  standalone: false,
})
export class RecentlyViewedTicketsComponent implements OnInit {
  tickets: Ticket[] = [];
  loading = false;

  constructor(
    private tcDataService: TcDataService,
    private tcTicketService: TcTicketService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadRecentlyViewedTickets();
  }

  async loadRecentlyViewedTickets() {
    let ticketIds = this.tcDataService.loadRecentlyViewedTickets();

    if (ticketIds && ticketIds.length) {
      this.loading = true;
      this.tickets = [];

      let findOptions = {
        page: 1,
        perPage: 100,
        filters: [
          new FilterField({
            name: 'in[id]',
            value: ticketIds,
            operator: FilterOperator.has,
            label: '',
          }),
        ],
      };

      let response = await this.tcTicketService.findAll(findOptions).catch(e => {
        console.error(e);
        this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
      });
      this.loading = false;

      if (response?.data?.length) {
        ticketIds.forEach(id => {
          let ticket = response!.data!.find(t => t.id === id);

          if (ticket) {
            this.tickets.push(ticket);
          }
        });
      }
    }
  }

  openTicket(ticket: Ticket) {
    this.router.navigate(['/v3ndor/chamados/' + ticket.id]);
  }
}
